import { styled } from '@mui/system'
import { colors } from '../../../../Components/consts'

type StyleProps = {
  resultStatus: 'W' | 'L' | 'T' | ''
}

export const ResultsTableCon = styled('table')(({ theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    background: colors.white,
    margin: theme.spacing(1),


    '& th': {
      fontSize: 10,
      color: colors.text,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      height: theme.spacing(3),
      '&:first-of-type': {
        textAlign: 'left',
      },
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },
    '& tbody td': {
      fontSize: 14,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: colors.text,
      minWidth: 28,
      textAlign: 'center',
      fontWeight: 600,
      '&:first-of-type': {
        width: 'auto',
        textAlign: 'left',
      },
      '& a': {
        color: colors.text,
        textDecoration: 'none',
      }
    },
}))

export const ResultText = styled('span')<StyleProps>(({ resultStatus }) => ({
  color: resultStatus === 'W' ? colors.darkGreen : resultStatus === 'L' ? colors.red : colors.yellow,
  fontWeight: 700
}))